import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrExecuteTermPayload } from 'api/actions/hr-execute-term/hr-execute-term-payload';
import { HrExecuteTermPathParameters } from 'api/actions/hr-execute-term/hr-execute-term-path-parameters';
import { HrExecuteTermResponse } from 'api/actions/hr-execute-term/hr-execute-term-response';

type HrExecuteTermQueryParameters = Record<string, any>;

/**
 * The path of the HrExecuteTerm action.
 */
export const hrExecuteTermActionPath = new SweetPath<keyof HrExecuteTermPathParameters>(
  '/api/hr/terms/{termId}/execute',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrExecuteTerm actions.
 */
export default function createHrExecuteTermAction(axios: AxiosInstance) {
  return function hrExecuteTermAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrExecuteTermPathParameters;
    query?: HrExecuteTermQueryParameters;
    payload: HrExecuteTermPayload;
  }) {
    const path = hrExecuteTermActionPath.insert(parameters);

    return axios.request<HrExecuteTermResponse, HrExecuteTermResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
